import styled from 'styled-components';

export const OverviewPageStyled = styled.div`
    display: flex;
    flex-direction: column;
    gap: var(--space-4);
    max-width: 960px;
    margin: 0 auto;
    padding-bottom: var(--space-6);

    .page-header {
        display: flex;
        flex-direction: column;
        gap: var(--space-1);
        margin-bottom: var(--space-2);
    }

    .page-title {
        margin: 0;
        font-size: var(--font-size-h3);
        font-weight: 600;
        line-height: 1.25;
        color: var(--color-white-95);
    }

    .page-desc {
        margin: 0;
        font-size: var(--font-size-md);
        color: var(--text-color-secondary);
    }
`;

export const OverviewSectionStyled = styled.section`
    padding: var(--space-5) var(--space-4);
    background: var(--color-surface);
    border-radius: var(--radius-md);

    .section-header {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        justify-content: space-between;
        gap: var(--space-3) var(--space-6);
        margin-bottom: var(--space-5);
    }

    .section-heading {
        display: flex;
        flex-direction: column;
        gap: var(--space-1);
        min-width: 0;
    }

    .section-title {
        margin: 0;
        font-size: var(--font-size-h4);
        font-weight: 600;
        color: var(--color-white-95);
    }

    .section-desc {
        margin: 0;
        font-size: var(--font-size-md);
        color: var(--text-color-secondary);
    }
`;

export const OverviewPeriodToggleStyled = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: var(--space-2);

    .period-btn {
        min-width: 4.5rem;
    }
`;

export const OverviewCardsStyled = styled.ul`
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: var(--space-3);
    margin: 0;
    padding: 0;
    list-style: none;

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
    }
`;

export const OverviewCardStyled = styled.li`
    display: flex;
    flex-direction: column;
    gap: var(--space-1);
    padding: var(--space-3) var(--space-4);
    background: var(--color-surface-secondary);
    border-radius: var(--radius-md);

    .card-label {
        margin: 0;
        font-size: var(--font-size-sm);
        font-weight: 600;
        color: var(--text-color-secondary);
    }

    .card-value {
        margin: 0;
        font-size: var(--font-size-xl);
        font-weight: 600;
        color: var(--color-white-95);
    }
`;

export const OverviewChartWrapStyled = styled.div`
    width: 100%;
    height: 280px;
    margin-top: var(--space-2);

    .recharts-cartesian-grid line {
        stroke: var(--color-white-10, rgba(255, 255, 255, 0.08));
    }

    .recharts-text {
        fill: var(--text-color-secondary);
        font-size: 12px;
    }

    .recharts-default-legend {
        color: var(--text-color-secondary);
    }
`;

export const OverviewChartTooltipStyled = styled.div`
    min-width: 10rem;
    padding: var(--space-3);
    background: var(--color-surface-secondary);
    border: 1px solid var(--color-white-10, rgba(255, 255, 255, 0.08));
    border-radius: var(--radius-md);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);

    .tooltip-label {
        margin: 0 0 var(--space-2);
        font-size: var(--font-size-sm);
        font-weight: 600;
        color: var(--text-color-secondary);
    }

    .tooltip-rows {
        display: flex;
        flex-direction: column;
        gap: var(--space-1);
        margin: 0;
        padding: 0;
        list-style: none;
    }

    .tooltip-row {
        display: grid;
        grid-template-columns: auto 1fr auto;
        align-items: center;
        gap: var(--space-2);
    }

    .tooltip-swatch {
        width: 0.5rem;
        height: 0.5rem;
        border-radius: 50%;
    }

    .tooltip-name {
        font-size: var(--font-size-sm);
        color: var(--text-color-secondary);
    }

    .tooltip-value {
        font-size: var(--font-size-sm);
        font-weight: 600;
        color: var(--color-white-95);
    }
`;
